import { Box } from '@mui/material';
import MediaEntetiesTable from '../../../common/MediaEntitiesTable';

const BaleTable = () => {
	return (
		<Box className="w-full">
			<MediaEntetiesTable media_id={6} />
		</Box>
	);
};

export default BaleTable;
